import type { UseMutationOptions, UseMutationResult } from '@tanstack/react-query/src/types';
import { AxiosError } from 'axios';
import { QueryClient, useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { ToastMessage } from '../utilities/ToastMessage';

export function useMutationWithErrorHandling<TData = unknown, TVariables = void, TContext = unknown>(
  options: UseMutationOptions<TData, AxiosError<{ errors: any[] }>, TVariables, TContext>,
  queryClient?: QueryClient
): UseMutationResult<TData, AxiosError, TVariables, TContext> {
  options = {
    ...options,
    onError: (error) => {
      const {type, status, detail, ...problemDetails}: any  = error.response.data || {};
      toast(<ToastMessage message={detail ?? error.message} errorData={problemDetails ?? error.response.data.errors} />);
    },
  };
  return useMutation(options, queryClient);
}
